/** @format */

import axios from 'axios';
import { toast } from 'react-toastify';
import { BaseUrl, getAuthHeaders } from '../components/BaseURl/BaseUrl';

const isRequestCanceled = error =>
  axios.isCancel?.(error) ||
  error?.code === 'ERR_CANCELED' ||
  error?.name === 'CanceledError' ||
  error?.name === 'AbortError';

const handleError = (error, customErrorMsg) => {
  const msg = error?.response?.data?.message || customErrorMsg;
  toast.error(msg);
};

const apiRequest = async (method, url, payload = null, options = {}) => {
  const {
    setResponse,
    setLoading,
    additionalFunctions = [],
    successMsg,
    errorMsg,
    onSuccess = () => {},
    onError = () => {},
    signal,
  } = options;

  if (setLoading) setLoading(true);

  try {
    let response;
    const authConfig = getAuthHeaders();
    const config = signal ? { ...authConfig, signal } : authConfig;

    if (method === 'get' || method === 'delete') {
      response = await axios[method](`${BaseUrl}${url}`, config);
    } else {
      response = await axios[method](`${BaseUrl}${url}`, payload, config);
    }

    if (setResponse) setResponse(response.data);

    // Display success message
    if (successMsg) toast.success(successMsg);

    // Run additional functions
    additionalFunctions.forEach(
      (func) => func && typeof func === 'function' && func(response?.data)
    );
    if (response?.data) {
      onSuccess(response?.data);
    }

    return response.data; // ✅ Return the response data
  } catch (error) {
    if (isRequestCanceled(error)) {
      return null;
    }
    handleError(error, errorMsg);
    if (error) onError(error);
    console.log(error);
    return null; // Return null on error
  } finally {
    if (setLoading) setLoading(false);
  }
};

export const getApi = (url, options) => apiRequest('get', url, null, options);
export const postApi = (url, payload, options) => apiRequest('post', url, payload, options);
export const putApi = (url, payload, options) => apiRequest('put', url, payload, options);
export const deleteApi = (url, options) => apiRequest('delete', url, null, options);
